import { useSyncExternalStore } from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

interface ToastAction { label: string; onClick: () => void }
interface Toast { id: number; text: string; kind: 'info' | 'error'; action?: ToastAction }
let toasts: Toast[] = [];
const listeners = new Set<() => void>();
let seq = 0;

function dismiss(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  listeners.forEach((l) => l());
}

/** Show a toast; an action (e.g. Undo) keeps it up longer. */
export function toast(text: string, kind: Toast['kind'] = 'info', action?: ToastAction) {
  const id = ++seq;
  toasts = [...toasts, { id, text, kind, action }];
  listeners.forEach((l) => l());
  setTimeout(() => dismiss(id), action ? 10_000 : kind === 'error' ? 6000 : 3200);
}

export function Toasts() {
  const items = useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => toasts,
  );
  return (
    <div className="toasts" role="status" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`}>
          {t.kind === 'error' ? <AlertCircle size={16} color="var(--danger)" /> : <CheckCircle2 size={16} color="var(--ready)" />}
          {t.text}
          {t.action && (
            <button className="btn sm" style={{ marginLeft: 8 }} data-testid="toast-action" onClick={() => { dismiss(t.id); t.action!.onClick(); }}>{t.action.label}</button>
          )}
        </div>
      ))}
    </div>
  );
}
